// Which of the four experiences this page load is.
//
// Production tells them apart by subdomain: admin.30min.tn, restaurant.30min.tn and
// driver.30min.tn are the three staff/partner consoles, and the bare domain (30min.tn, or
// www.30min.tn) is the customer-facing marketing site and web sign-up. A single Vite dev
// server has one hostname for all four, so ?surface= and VITE_DEFAULT_SURFACE stand in —
// and both default to "customer", which is the app's existing behaviour, so a dev server or
// a test that renders <App /> with no hostname or override keeps working exactly as it did
// before this file existed.

export type Surface = "admin" | "restaurant" | "driver" | "customer";

const SURFACES: readonly Surface[] = ["admin", "restaurant", "driver", "customer"];

function isSurface(value: string | null): value is Surface {
  return value !== null && (SURFACES as readonly string[]).includes(value);
}

const LABEL_TO_SURFACE: Record<string, Surface> = {
  admin: "admin",
  restaurant: "restaurant",
  driver: "driver",
};

export function currentSurface(
  hostname: string = window.location.hostname,
  search: string = window.location.search,
): Surface {
  // A manual override for local QA — open the same dev server as
  // http://localhost:5173/?surface=driver to see the driver console without a real subdomain.
  const override = new URLSearchParams(search).get("surface");
  if (isSurface(override)) return override;

  const label = hostname.split(".")[0];
  const matched = LABEL_TO_SURFACE[label];
  if (matched) return matched;

  const fallback = import.meta.env.VITE_DEFAULT_SURFACE as string | undefined;
  if (isSurface(fallback ?? null)) return fallback as Surface;

  return "customer";
}
